
import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class APIService {

    static getCustomField(CompanyCode, email) {
        //var data = [];
        return axios.get(`${BaseUrl}CustomField?CompanyCode=${CompanyCode}&email=${email}`);
    }
}


// WEBPACK FOOTER //
// ./src/Services/CustomField/CustomField.js